import React from 'react';
import { ArrowRight, Mail, CheckCircle } from 'lucide-react';
import { CONTACT_SECTION } from '../constants';
import { useLanguage } from '../LanguageContext';

export default function ContactSection() {
  const { lang }  = useLanguage();
  const section   = CONTACT_SECTION[lang];

  return (
    <section className="pb-section pb-section-pad" id="contact" data-testid="pb-contact">
      <div className="pb-container">
        <div className="pb-contact-card">
          <div className="pb-contact-orb pb-contact-orb--1" />
          <div className="pb-contact-orb pb-contact-orb--2" />

          <div className="pb-contact-inner">
            {/* Colonne gauche */}
            <div className="pb-contact-left">
              <div className="pb-label pb-contact-label">{section.label}</div>
              <h2 className="pb-contact-title" data-testid="pb-contact-title">
                {section.title.split('\n').map((line, i) => (
                  <React.Fragment key={i}>{line}{i === 0 && <br />}</React.Fragment>
                ))}
              </h2>
              <p className="pb-contact-sub">{section.sub}</p>
              <ul className="pb-contact-trust">
                {section.trust.map((pt, i) => (
                  <li key={i} className="pb-contact-trust-item">
                    <CheckCircle size={15} className="pb-contact-trust-icon" />
                    {pt}
                  </li>
                ))}
              </ul>
            </div>

            {/* Colonne droite */}
            <div className="pb-contact-right">
              <div className="pb-contact-cta-box">
                <p className="pb-contact-cta-hint">{section.hint}</p>
                <button
                  className="pb-btn-primary pb-contact-btn"
                  onClick={() => window.dispatchEvent(new CustomEvent('openDemoModal'))}
                  data-testid="pb-contact-demo-btn"
                >
                  {section.btn}
                  <ArrowRight size={16} />
                </button>
                <p className="pb-contact-email">
                  <Mail size={13} />
                  <a href="mailto:cockpit@pitboardsuite.com" data-testid="pb-contact-email-link">
                    cockpit@pitboardsuite.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
